import react, { useState, useEffect, useRef } from "react";
import { Link, useParams } from "react-router-dom";
import Menu from "../../../../Layout/Menu/Menu";
import { Navigation, NavigationMobile } from "../../../Navigation/Menu";
import { Puff } from "react-loading-icons";
import EventTablesRequest from "../EventTablesRequest";
import Table from "../../../../Layout/Table/Table";
import { Grid, EstadoCellRenderer } from "../../../../Layout/Grid/GridView";
import NavBar from "../../../../../components/NavBar";

const TransactionsList = () => {
  let params = useParams();
  const gridRef = useRef();
  const [isLoading, setIsLoading] = useState(false);
  const [state, setState] = useState({
    transactions: [],
    event: {
      id: 0,
      name: "",
      id_venues: "",
    },
  });

  const InsideLoading = () => {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
          flexDirection: "column",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            maxWidth: "100%",
          }}
        >
          <Puff stroke="#f92056" height="5em" width="5em" />
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            maxWidth: "100%",
          }}
        >
          Loading...
        </div>
      </div>
    );
  };

  const getListTransactions = async () => {
    setIsLoading(true);
    let info = await EventTablesRequest.getListTransactionsEvent({
      id_events: params.id,
    });
    if (info && info.status) {
      setState(info.data);
    }
    setIsLoading(false);
  };

  useEffect(() => {
    getListTransactions();
  }, []);

  const columns = [
    "Método Pagamento",
    "Data",
    "Nome Cliente",
    "Telefone Cliente",
    "Valor",
    "Data Pagamento",
    "Estado",
  ];

  const StatusColumn = ({ status, label }) => {
    return (
      <div className={`status-column ${status.toString().toLowerCase()}`}>
        {label}
      </div>
    );
  };

  const PaymentMethod = ({ method }) => {
    return (
      <div className="text-center">
        <img
          src={`/img/payments/${method}.png`}
          className="img-fluid"
          style={{ height: "25px", width: "auto" }}
        />
      </div>
    );
  };

  const serializeRowsColums = () => {
    return state.transactions.map((item) => {
      return {
        ...item,
        "Método Pagamento": <PaymentMethod method={item.payment_method} />,
        Estado: <StatusColumn status={item.status} label={item.Estado} />,
      };
    });
  };

  return (
    <div>
      <NavBar>
        <div className="row">
          <div className="col-sm-12 dashboard-content">
            {isLoading ? (
              <InsideLoading />
            ) : (
              <>
                <div className="row">
                  <div className="col-12">
                    <nav>
                      <ol className="breadcrumb">
                        <li className="breadcrumb-item">
                          <Link to="/my/dashboard">
                            <i className="fa-solid fa-home"></i>
                          </Link>
                        </li>
                        <li className="breadcrumb-item">
                          <Link to="/my/events/">Eventos</Link>
                        </li>
                        <li className="breadcrumb-item">
                          <Link to={`/my/events/${params.id}/tables`}>
                            Gestor de Mesas
                          </Link>
                        </li>
                        <li
                          className="breadcrumb-item active"
                          aria-current="page"
                        >
                          Lista de pagamentos
                        </li>
                      </ol>
                    </nav>
                  </div>
                </div>
                <div className="row">
                  <div className="col-12 col-sm-8">
                    <h2 className="dashboard-h2">
                      Evento: {state.event.name}{" "}
                      <small style={{ color: "#ea2c61" }}>|</small>{" "}
                      <small style={{ fontWeight: "100" }}>
                        {state.event.date_formated}
                      </small>
                    </h2>
                  </div>
                </div>

                <div className="row mt-3">
                  <div className="col-12">
                    {/* <Table
                                            columns={columns}
                                            data={serializeRowsColums(state.transactions)}
                                            currentPage={1}
                                            itemsPerPage={1000}
                                            totalItems={state.transactions.length}
                                        /> */}
                    <Grid
                      ref={gridRef}
                      rows={state.transactions}
                      cols={[
                        { hide: true, field: "id" },
                        {
                          headerName: "Método Pagamento",
                          field: "payment_method",
                          cellRenderer: (params) => {
                            return (
                              <div className="text-center">
                                <img
                                  src={`/img/payments/${params.data.payment_method.toLowerCase()}.png`}
                                  className="img-fluid"
                                  style={{ height: "25px", width: "auto" }}
                                />
                              </div>
                            );
                          },
                        },
                        { headerName: "Data", field: "date" },
                        { headerName: "Cliente", field: "client_name" },
                        {
                          headerName: "Telemóvel",
                          field: "client_phone_number",
                        },
                        {
                          headerName: "Valor",
                          cellStyle: { textAlign: "right" },
                          field: "value",
                        },
                        { headerName: "Data Pagamento", field: "payment_date" },
                        {
                          headerName: "Estado",
                          field: "status",
                          cellRenderer: EstadoCellRenderer,
                        },
                      ]}
                    />
                  </div>
                </div>
              </>
            )}
          </div>
        </div>
      </NavBar>
    </div>
  );
};

export default TransactionsList;
